import {Directive, effect, ElementRef, inject, input} from '@angular/core';
import {distinctUntilChanged, fromEvent, map} from 'rxjs';

// Usage: <h1 [appScrollOpacity]="scrollContainerElement">Title</h1>
// The element's opacity will fade from 0 to 1 as the container scrolls from 0 to scrollDistance pixels.

@Directive({
    selector: '[appScrollOpacity]',
    standalone: true,
})
export class ScrollOpacityDirective {
    readonly scrollContainer = input.required<HTMLElement>({alias: 'appScrollOpacity'});
    readonly scrollDistance = input<number>(100);

    private readonly el = inject<ElementRef<HTMLElement>>(ElementRef);

    constructor() {
        effect(onCleanup => {
            const container = this.scrollContainer();
            const distance = this.scrollDistance();
            const element = this.el.nativeElement;

            if (container === undefined) {
                return;
            }

            element.style.opacity = '0';

            const subscription = fromEvent(container, 'scroll', {passive: true})
                .pipe(
                    map(() => Math.min(Math.max(container.scrollTop / distance, 0), 1)),
                    distinctUntilChanged(),
                )
                .subscribe(opacity => (element.style.opacity = opacity.toString()));

            onCleanup(() => subscription.unsubscribe());
        });
    }
}
